'use client';

import type { FC } from 'react';
import type { ProviderDto } from '@/queries/providers';
import Image from 'next/image';
import { cn } from '@/utils/cn';

interface ProviderBannerProps {
  className?: string;
  provider: ProviderDto;
}

export const ProviderBanner: FC<ProviderBannerProps> = ({ className, provider }) => {
  return (
    <div
      className={cn('relative justify-between flex-col-reverse h-full md:flex-row w-full overflow-hidden flex items-center rounded-2xl', className)}
    >
      {
        provider.desktopCover && (
          <div className="relative hidden w-full xss:block h-[clamp(8.75rem,18vw,15rem)]">
            <Image
              fill
              alt={provider.desktopCover.meta?.alt || provider.name}
              src={provider.desktopCover?.key || provider.desktopCover?.path}
              className="object-cover object-left"
              sizes="(max-width: 479px) 1px, (max-width: 1024px) 100vw, 1128px"
              priority
            />
          </div>
        )
      }
      {
        provider.mobileCover && (
          <div className="relative w-full xss:hidden aspect-328/345">
            <Image
              fill
              alt={provider.mobileCover.meta?.alt || provider.name}
              src={provider.mobileCover?.key || provider.mobileCover?.path}
              className="object-cover"
              sizes="(max-width: 479px) 100vw, 1px"
              priority
            />
          </div>
        )
      }
    </div>
  );
};
